import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  list: {
    paddingLeft: theme.spacing(3),
  },
  item: {
    paddingBottom: theme.spacing(0.5),
  },
}));

export default useStyles;
